import moment from "moment/moment";
import React, { useState } from "react";
import Select from "react-select";
import { useAuthState } from "../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { DepartmentNameDDL } from "../../../../Components/CommonDDL/DepartmentNameDDL";
import { DesignationNameDDL } from "../../../../Components/CommonDDL/DesignationDDL";
import { StatusNameDDL } from "../../../../Components/CommonDDL/StatusNameDDL";
import { RoleManagerDDL } from "../../../../Components/CommonDDL/RoleManagerDDL";
import { EmployeeNameDDL } from "../../../../Components/CommonDDL/EmployeeNameDDL";
import { UserCreationPostAPI } from "../../../../Helper/Redux/MasterSlice/UserCreationSlice.js";
import { AstricSign } from "../../../../Helper/AstricSign.js";

export default function AddUserCreationPopUp(props) {
  const { handleShowAddModal, handleIsPost, ShowAddModal } = props
  const { flag, data } = ShowAddModal

  const userDetails = useAuthState();
  const { UserID, token } = userDetails
  const dispatch = useDispatch()

  const [DepartmentNameID, setDepartmentNameID] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",
  })
  const [RoleDDLID, setRoleDDLID] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",
  })
  const [DesignationNameID, setDesignationNameID] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",
  })
  const [EmployeeNameID, setEmployeeNameID] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",
  })
  const [StatusID, setStatusID] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",
  })
  const [Username, setUsername] = useState(data && data.userName ? data.userName : '')
  const [Password, setPassword] = useState(data && data.password ? data.password : '')
  const [Date, setDate] = useState(data && data.joiningDate ? moment(data.joiningDate).format('YYYY-MM-DD') : '')

  const handleSubmit = () => {
    const data = {
      M_DepartmentMasterID: DepartmentNameID.ID,
      M_TableUserMasterID: flag == 'Update' ? ShowAddModal.data.m_TableUserMasterID : 0,
      M_RoleManagerID: RoleDDLID.ID,
      M_DesignationMasterID: DesignationNameID.ID,
      M_EmployeeMasterID: EmployeeNameID.ID,
      TableNameNo: '',
      UserName: Username,
      Password: Password,
      StatusIndicatorMasterID: StatusID.ID,
      JoiningDate: Date && moment(Date).format('YYYY-MM-DD'),
      UserID: UserID,
      Flag: flag,
      token: token,
      handleIsPost: handleIsPost
    }
    dispatch(UserCreationPostAPI({ data }))
  }

  const { isPostLoading } = useSelector(state => state.DepartmentMasterPostData)

  const handleClear = () => {
    setRoleDDLID({
      ...RoleDDLID,
      ID: 0,
      Label: 'Select...'
    })
    setDepartmentNameID({
      ...DepartmentNameID,
      ID: 0,
      Label: 'Select...'
    })
    setDesignationNameID({
      ...DesignationNameID,
      ID: 0,
      Label: 'Select...'
    })
    setEmployeeNameID({
      ...EmployeeNameID,
      ID: 0,
      Label: 'Select...'
    })
    setStatusID({
      ...StatusID,
      ID: 0,
      Label: 'Select...'
    })
    setUsername('')
    setPassword('')
    setDate('')
  }
  console.log(data)

  const handleClearCancel = () => {
    flag == 'Update' ? handleShowAddModal(false, '') : handleClear()
  }

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "#00000055" }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header pl-4">
              <h5 className="modal-title" id="exampleModalLongTitle">
                User Creation/ User Transfer
              </h5>
              <button
                onClick={() => handleShowAddModal(false, '')}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mx-4">
              <div className="row">
                <div className=" col-lg-4">
                  <div className="form-group m-0">
                    <RoleManagerDDL
                      RoleDDLID={RoleDDLID}
                      setRoleDDLID={setRoleDDLID}
                      Flag={flag}
                      data={data}
                      AstricSignFlag = "AstricSign"
                    />
                  </div>
                </div>
                <div className=" col-lg-4">
                  <DepartmentNameDDL
                    DepartmentNameID={DepartmentNameID}
                    setDepartmentNameID={setDepartmentNameID}
                    apiFlag='Master '
                    Flag={flag}
                    data={data}
                    IsPost=''
                    AstricSignFlag = "AstricSign"
                  />
                </div>
                <div className=" col-lg-4">
                  <DesignationNameDDL
                    DesignationNameID={DesignationNameID}
                    setDesignationNameID={setDesignationNameID}
                    apiFlag='Master '
                    Flag={flag}
                    data={data}
                    IsPost=''
                    AstricSignFlag = "AstricSign"
                  />
                </div>
                <div className=" col-lg-4  mt-lg-3">
                  <EmployeeNameDDL
                    EmployeeNameID={EmployeeNameID}
                    setEmployeeNameID={setEmployeeNameID}
                    DesignationNameID={DesignationNameID}
                    Flag={flag}
                    data={data}
                    AstricSignFlag = "AstricSign"
                  />
                </div>

                <div className="col-xl-4 col-lg-4 mt-lg-3">
                  <div className="form">
                    <label>
                      Username <AstricSign/>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="Username"
                      placeholder="Username"
                      value={Username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 mt-lg-3">
                  <div className="form">
                    <label>
                      Password <AstricSign/>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="Password"
                      placeholder="Password"
                      value={Password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                </div>

                <div className=" col-lg-4 mt-lg-3">
                  <StatusNameDDL
                    StatusID={StatusID}
                    setStatusID={setStatusID}
                    Flag={flag}
                    data={data}
                    IsPost=''
                  />
                </div>

                <div className="col-xl-4 col-lg-4 mt-lg-3">
                  <div className="form">
                    <label>
                      Joining date <AstricSign/>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="JoiningDate"
                      placeholder="Joining Date"
                      value={Date}
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group float-end mt-lg-3 mt-3">

                    <button type="button" className="btn btn-outline-dark border-2 mx-2"
                     disabled={ RoleDDLID.ID== 0 || DepartmentNameID.ID == 0 || DesignationNameID.ID == 0 || 
                      EmployeeNameID.ID == 0 || Username == "" || Password == "" || Date == "" }
                      onClick={handleSubmit}> {flag == 'Update' ? "Update" : "Add"}</button>

                    <button type="button" className="btn btn-danger border-2"
                      onClick={handleClearCancel}>
                      {flag == 'Update' ? "Cancel" : "Clear"}
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
